<p-table [value]="allPaymentMethods" dataKey="id">
  <ng-template pTemplate="header">
    <tr>
      <th>Name</th>
      <th>Type</th>
      <th>Is Active</th>
      <th>Action</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-payment>
    <tr>
      <td>{{payment.name}}</td>
      <td>{{payment.type?payment.type.name:''}}</td>
      <td>{{payment.statusId==statusConstants.ACTIVE?answertypeConstants.Yes:answertypeConstants.No}}</td>
      <td class="action">
        <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"><i class="pi
            pi-pencil" (click)="showEditPaymentMethod(payment)"></i></span>
        <span class="btnBars p-mr-0" pTooltip="Delete" (click)="checkDeleteStatus(payment)" tooltipPosition="top"><i
            class="pi pi-trash"></i></span>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td colspan="7" class="p-text-center">
        {{dataMessage}}
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog header="{{addEditPaymentMethodHeader}}" [(visible)]="display" [modal]="true"
  [responsive]="true" [style]="{width: '60vw'}" (onHide)="hideDialog()">
  <form [formGroup]="paymentMethodForm">
    <div class="header">
      <h5>Payment Method Information
        <p-inputSwitch class="header-switch" formControlName="statusId"
          (onChange)="checkPaymentMethodStatus()"></p-inputSwitch>
      </h5>
    </div>
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-md-6">
          <label>Name <span style="color: red;">*</span></label>
          <input pInputText type="text" formControlName="name" />
          <small *ngIf="invalidData" class="p-invalid">Name already exists.</small>
        </div>
        <div class="p-col-12 p-md-6">
          <label>Type</label>
          <p-dropdown [options]="allMethodTypes" formControlName="typeId" optionLabel="name" placeholder="Select Type"
            [ngModelOptions]="{standalone: true}" appendTo="body" (onChange)="addNewOption(paymentMethodForm.value)">
          </p-dropdown>
        </div>
      </div>
      @if(index==3){
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-6">
            <label>Finance Account<span style="color: red;">*</span></label>
            <p-treeSelect class="border-bottom-input" [options]="bankAccounts" appendTo="body"
              formControlName="financialAccountId" display="comma" placeholder="Select Financial Account"
              [metaKeySelection]="false" selectionMode="single"></p-treeSelect>
          </div>
        </div>
      }
     
    </div>
  </form>
  <p-footer>
    <button type="button" pButton (click)="display=false" label="Cancel"
      class="p-button-secondary"></button>
    <button type="button" pButton [disabled]="!paymentMethodForm?.valid"
      (click)="savePaymentMethod(paymentMethodForm.value)" label="Save"></button>
  </p-footer>
</p-dialog>

<p-dialog header="{{addEditOptionHeader}}" [modal]="true" [(visible)]="displayAddNewOption" [style]="{width: '50vw'}"
  [baseZIndex]="10000" (onHide)="addNewOptionForm.reset()">
  <form [formGroup]="addNewOptionForm">
    <div class="p-grid">
      <div class="p-col-6">
        <label for="name">Type Name <span style="color: red;">*</span></label>
        <input type="text" pInputText formControlName="name">
        <small *ngIf="invalidTypeData" class="p-invalid">Name already exists.</small>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button pButton (click)="displayAddNewOption=false" label="Cancel" class="p-button-secondary"></button>
    <button pButton [disabled]="!addNewOptionForm.valid" (click)="saveType(addNewOptionForm.value)"
      label="Save"></button>
  </ng-template>
</p-dialog>